import { angieRoutePrefix } from 'src/app/globals';
import { ReflectionsRoutesConfig } from '../reflections-routes.config';

export class ReflectionsRoutes {
	public static NEW_CHAT_ROUTE = `${ReflectionsRoutesConfig.REFLECTIONS_BASE_URL}/${ReflectionsRoutesConfig.CHATS_SEGMENT}/${ReflectionsRoutesConfig.NEW_SEGMENT}`;

	public static REFLECTIONS_NEW_CHAT = (enrollmentId: number): string =>
		angieRoutePrefix.concat(`/${ReflectionsRoutes.NEW_CHAT_ROUTE}?enrollment_id=${enrollmentId}`);
	public static CHAT_MESSAGES = (chatId: string): string =>
		angieRoutePrefix.concat(`/reflections/chats/${chatId}/messages.json`);

	public static GET_MESSAGE = (chatId: string, messageKey: string): string =>
		angieRoutePrefix.concat(`/reflections/chats/${chatId}/messages/${messageKey}.json`);
}
